import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { SeoCtaItem } from '../../../business/seo/seo-cta-item';

@Component({
    selector: 'ecm-mat-cta',
    templateUrl: 'material-seo-cta.html',
    styleUrls: ['material-seo-cta.css'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialSeoCtaComponent {
    public items = input<SeoCtaItem[]>([]);
    public e2e = input<string>('e2e-mat-seo-cta');
    public clickCtaLink = output();

    public emitLoginEvent(item) {
        this.clickCtaLink.emit(item.id);
    }
}
